import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32572966"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "400",
  height: "400"
}

import { debounce } from '@/utils';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'radar',
  setup(__props) {

class slogonShape {
    x = 0
    y = 0
    r = 100
    n = 6
    level = 5
}

class shapConfig {
    lineColor = '#d7d7d7'
    shapeColor = '#bcbcbc'

}

class Isogon {
    config: shapConfig
    slogonShape: slogonShape
    point: Array<Array<number>>
    constructor(opts?: shapConfig) {
        this.config = new shapConfig();
        this.point = [];
        this.slogonShape = new slogonShape();
    }

    drawShape(ctx: CanvasRenderingContext2D, slogonShape: slogonShape, config: shapConfig) {
        const { x, y, r, n } = slogonShape;
        const { shapeColor } = config;
        ctx.translate(x, y);
        ctx.strokeStyle = shapeColor;

        const itemPoint = [];
        for (let i = 0; i < n; i++) {
            const rotation = ((Math.PI * 2) / n) * i;
            const x = r * Math.cos(rotation);
            const y = r * Math.sin(rotation);
            itemPoint.push([x, y]);
            if (i === 0) {
                ctx.moveTo(x, y);
            } else {
                ctx.lineTo(x, y);
            }
        }
        this.point.push(itemPoint);
        ctx.closePath();
        ctx.stroke();
    }

    drawLine(ctx: CanvasRenderingContext2D, slogonShape: slogonShape, config: shapConfig) {
        const { x, y, r, n } = slogonShape;
        const { lineColor } = config;
        ctx.translate(x, y);
        ctx.strokeStyle = lineColor;
        for (let i = 0; i < n; i++) {
            const rotation = ((Math.PI * 2) / n) * i;
            ctx.moveTo(0, 0);
            ctx.lineTo(r * Math.cos(rotation), r * Math.sin(rotation));
        }
        ctx.closePath();
        ctx.stroke();
    }

    drawShapeColor(ctx: CanvasRenderingContext2D, rect: string | any[], color: string | CanvasGradient | CanvasPattern) {
        ctx.save()
        ctx.beginPath() //开始路径
        ctx.lineWidth = 0  //设置边框为0
        ctx.fillStyle = color //设置填充颜色
        ctx.moveTo(rect[0][0], rect[0][1]) //将画笔移动到第一个顶点
        for (let i = 1; i < rect.length; i++) {
            ctx.lineTo(rect[i][0], rect[i][1]) //绘制直线到第二个顶点
        }
        ctx.closePath() //闭合路径
        ctx.fill() //填充颜色

        ctx.restore()
    }

    setBackGroundColor(ctx: CanvasRenderingContext2D, color: string) {
        const rectList = [];
        this.point.forEach((shape, index) => {
            if (index === 0 || index === 2 || index === 4) {
                for (let i = 0; i < shape.length; i++) {
                    const nextIndex = i + 1 === shape.length ? 0 : i + 1;
                    const nextShape = index + 1 === this.point.length ? this.point[0] : this.point[index + 1];
                    rectList.push([shape[i], shape[nextIndex], nextShape[nextIndex], nextShape[i]]);
                }
            }

        });
        // '#f6f2fcb2'
        rectList.forEach((rect) => {
            this.drawShapeColor(ctx, rect, color)
        })

    }

    renderText(ctx: CanvasRenderingContext2D) {
        const textList = ['绿茶', '红茶', '白茶', '黑茶', '普洱', '青茶'];

        this.point[this.point.length - 1].forEach((item: any, index: number) => {
            let [x, y] = item;
            const text = textList[index];
            ctx.font = "bold 20px serif";

            const radian = Math.atan2(y, x) / Math.PI;
            const textMetrics = ctx.measureText(text);

            if (x < 0) x -= textMetrics.width;
            if (radian === 0 || radian === 1) {
                y += 8;
            } else if (y > 0) {
                y += 20;
            }

            ctx.fillText(text, x, y);
        })

    }

    getLevel(c: number, l: number): any {
        return this.point[l][c]
    }

    randomLevel(ctx: CanvasRenderingContext2D) {
        ctx.save()
        ctx.beginPath()
        ctx.lineWidth = 1
        ctx.fillStyle = '#4169e17f'

        for (let i = 0; i < this.point.length; i++) {
            const randomNumber = Math.floor(Math.random() * 6);

            const [x, y] = this.getLevel(i, randomNumber);
            if (i === 0) {
                ctx.moveTo(x, y)
            } else {
                ctx.lineTo(x, y)
            }
        }

        ctx.closePath()
        ctx.fill()
        ctx.restore()
    }

    buildPath(ctx: CanvasRenderingContext2D, shape: slogonShape) {
        this.slogonShape = shape
        for (let i = 0; i <= this.slogonShape.level; i++) {
            shape.r = 20 + (i * 20)
            this.drawShape(ctx, shape, this.config);
            if (i === this.slogonShape.level) {
                this.drawLine(ctx, shape, this.config);
            }
        }
        this.setBackGroundColor(ctx, '#f6f2fcb2');

        this.randomLevel(ctx);
        this.renderText(ctx);
        return;
    }



}

onMounted(() => {
    const canvas = document.querySelector('canvas');

    const { left, top } = canvas.getBoundingClientRect();



    const ctx = canvas.getContext('2d');
    const { width, height } = canvas;

    ctx.translate(0.5 * width, 0.5 * height);

    const isogon = new Isogon();

    isogon.buildPath(ctx, {
        x: 0,
        y: 0,
        r: 0,
        n: 6,
        level: 5
    });

    canvas.addEventListener('mousemove', debounce((e) => {
        const { pageX, pageY } = e;

        const relativeX = (pageX - left) - (canvas.width / 2);
        const relativeY = (canvas.height / 2) - (pageY - top);

        const deg = Math.atan2(relativeY, relativeX) / Math.PI * 180;

        const maxPoint = isogon.point[isogon.point.length - 1];

        maxPoint.forEach((item, index) => {
            const next = index === maxPoint.length - 1 ? 0 : index + 1;

            const startDeg = Math.atan2(item[1], item[0])/ Math.PI * 180;

            const endDeg = Math.atan2(maxPoint[next][1], maxPoint[next][0])/ Math.PI * 180;

            if (deg > startDeg && endDeg < deg) {
            
            }
        });
        
       
    }, 8))

    console.log(isogon.point)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", _hoisted_1))
}
}

})